












import { IReferenceAlbum } from "@/store/types";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import FactoryReferenceItem from "./FactoryReferenceItem.vue";

@Component({
    components: {ReferenceItem: FactoryReferenceItem}
})
export default class FactoryReferences extends Vue {
    @State("albums")
    public albums: IReferenceAlbum[];
}
